import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { IconButton } from '@mui/material';
import { MouseEvent } from 'react';

interface CommentButtonProps {
  disabled: boolean;
  isOpen: boolean;
  onClick?: () => void;
}

const CommentButton = ({ disabled, isOpen, onClick }: CommentButtonProps) => {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onClick?.();
  };

  return (
    <IconButton
      size="small"
      aria-label={isOpen ? 'Hide comment' : 'Add comment'}
      color={isOpen ? 'primary' : 'default'}
      disabled={disabled}
      onClick={handleClick}
    >
      <ChatBubbleOutlineIcon fontSize="small" />
    </IconButton>
  );
};

export default CommentButton;
